interface MemberRemovalNotificationParams {
  organizationName: string;
  memberName?: string | undefined;
}

export const memberRemovalNotificationEmail = ({
  organizationName,
  memberName,
}: MemberRemovalNotificationParams) => ({
  subject: `You have been removed from ${organizationName} - Data Revival`,
  html: `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
      </head>
      <body style="margin: 0; padding: 0; background-color: #f3f4f6; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background-color: #f3f4f6;">
          <tr>
            <td align="center" style="padding: 40px 20px;">
              <table role="presentation" width="600" cellspacing="0" cellpadding="0" style="max-width: 600px; width: 100%;">

                <!-- Header -->
                <tr>
                  <td align="center" style="padding-bottom: 32px;">
                    <img src="https://app.data-revival.com/DataRevival_FC_RGB.png" alt="Data Revival" height="32" style="display: block;">
                  </td>
                </tr>

                <!-- Main Card -->
                <tr>
                  <td style="background-color: #ffffff; border-radius: 12px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);">
                    <table role="presentation" width="100%" cellspacing="0" cellpadding="0">

                      <!-- Card Content -->
                      <tr>
                        <td style="padding: 40px;">
                          <h1 style="margin: 0 0 24px 0; font-size: 24px; font-weight: 600; color: #111827; line-height: 1.3;">
                            You have been removed from ${organizationName}
                          </h1>
                          <p style="margin: 0 0 20px 0; font-size: 16px; color: #4b5563; line-height: 1.6;">
                            Hi${memberName ? ` ${memberName}` : ""},
                          </p>
                          <p style="margin: 0 0 20px 0; font-size: 16px; color: #4b5563; line-height: 1.6;">
                            This is to inform you that you have been removed from <strong style="color: #111827;">${organizationName}</strong> on Data Revival.
                          </p>
                          <p style="margin: 0 0 20px 0; font-size: 16px; color: #4b5563; line-height: 1.6;">
                            If you no longer belong to any organisations, your account will automatically revert to a free account and all free features will be available to you.
                          </p>
                          <p style="margin: 0; font-size: 16px; color: #4b5563; line-height: 1.6;">
                            If you believe this was done in error, please contact the organisation administrator.
                          </p>
                        </td>
                      </tr>

                    </table>
                  </td>
                </tr>

                <!-- Footer -->
                <tr>
                  <td style="padding: 32px 20px; text-align: center;">
                    <p style="margin: 0 0 8px 0; font-size: 14px; color: #6b7280; line-height: 1.5;">
                      Best regards,<br>
                      The Data Revival Team
                    </p>
                    <p style="margin: 16px 0 0 0; font-size: 12px; color: #9ca3af;">
                      &copy; ${new Date().getFullYear()} Data Revival Ltd. All rights reserved.
                    </p>
                  </td>
                </tr>

              </table>
            </td>
          </tr>
        </table>
      </body>
    </html>
  `,
  text: `You have been removed from ${organizationName}

Hi${memberName ? ` ${memberName}` : ""},

This is to inform you that you have been removed from ${organizationName} on Data Revival.

If you no longer belong to any organisations, your account will automatically revert to a free account and all free features will be available to you.

If you believe this was done in error, please contact the organisation administrator.

Best regards,
The Data Revival Team

© ${new Date().getFullYear()} Data Revival Ltd. All rights reserved.`,
});
